import { Risk } from '@/types';

export const mockRisks: Risk[] = [
  {
    id: 'risk-1',
    projectId: '1',
    name: 'Weather Delays',
    description: 'Potential delays due to adverse weather conditions during construction phase',
    probability: 3,
    impact: 2,
    owner: 'Project Manager',
    mitigation: 'Build weather contingency into schedule, monitor forecasts closely',
    status: 'open',
    stage: 2,
    dateIdentified: new Date('2024-01-20'),
    dateUpdated: new Date('2024-01-25')
  },
  {
    id: 'risk-2',
    projectId: '1',
    name: 'Material Cost Inflation',
    description: 'Rising costs of steel and concrete impacting budget',
    probability: 4,
    impact: 4,
    owner: 'Quantity Surveyor',
    mitigation: 'Lock in material prices early, identify alternative suppliers',
    status: 'monitoring',
    stage: 1,
    dateIdentified: new Date('2024-02-01'),
    dateUpdated: new Date('2024-02-15')
  },
  {
    id: 'risk-3',
    projectId: '1',
    name: 'Planning Permission Delay',
    description: 'Local authority may request additional information causing delays',
    probability: 2,
    impact: 3,
    owner: 'Planning Consultant',
    mitigation: 'Pre-application consultation, comprehensive submission',
    status: 'closed',
    stage: 2,
    dateIdentified: new Date('2024-01-15'),
    dateUpdated: new Date('2024-03-01')
  },
  {
    id: 'risk-4',
    projectId: '2',
    name: 'Heritage Restrictions',
    description: 'Conservation requirements may limit design options',
    probability: 3,
    impact: 3,
    owner: 'Heritage Specialist',
    mitigation: 'Early engagement with conservation officer, flexible design approach',
    status: 'open',
    stage: 0,
    dateIdentified: new Date('2024-02-20'),
    dateUpdated: new Date('2024-02-25')
  },
  {
    id: 'risk-5',
    projectId: '2',
    name: 'Structural Surprises',
    description: 'Unknown structural issues may be discovered during renovation',
    probability: 4,
    impact: 4,
    owner: 'Structural Engineer',
    mitigation: 'Comprehensive structural survey, contingency budget allocation',
    status: 'monitoring',
    stage: 1,
    dateIdentified: new Date('2024-03-01'),
    dateUpdated: new Date('2024-03-10')
  }
];